import React from 'react';
import Home from './Home/Home';
import { BrowserRouter,Route,Routes } from 'react-router-dom';
import About from './About/About';
import Menu from './Menu';


import Services from './Services/Services';
import Booking from './Booking/Booking';
import Contact from './Contact/Contact';
import Login from './Login/Login';
import Cleaning from './Services/Cleaning';
import Carpenter from './Services/Carpenter';
import Plumbing from './Services/Plumbing';
import Electrician from './Services/Electrician';
import ProductDetail from './Services/ProductDetail';
import Registration from './Registration/Registration';
import UserProfile from './User Profile/UserProfile';
import Notification from './Notification';
function App() {
  return (
    <div>
    <BrowserRouter>
    <Menu/>
   {/* <Login/> */}
    <Routes>
    <Route path="/" element={<Home/>}></Route>
    <Route path="/Home" element={<Home/>}></Route>
    <Route path="/About" element={<About/>}></Route>  

    <Route path="/Notification" element={<Notification/>}></Route>
    <Route path="/Services" element={<Services/>}></Route>
    <Route path="/Cleaning" element={<Cleaning/>}></Route>
    <Route path="/Carpenter" element={<Carpenter/>}></Route>
    <Route path="/Plumbing" element={<Plumbing/>}></Route>
    <Route path="/Electrician" element={<Electrician/>}></Route>
    <Route path="/Booking" element={<Booking/>}></Route>

    <Route path="/Contact" element={<Contact/>}></Route>
    <Route path="/Login" element={<Login/>}></Route>
    <Route path="/ProductDetail" element={<ProductDetail/>}></Route>
    <Route path="/Registration" element={<Registration/>}></Route>
    <Route path="/UserProfile" element={<UserProfile/>}></Route>
   
    </Routes>
    </BrowserRouter>
    </div>
    
  );
}

export default App;
